import { gate as v3Gate } from 'hub-http/gates';
import { hasGate } from './auth';

/**
 * Contract gates and release definition can be found in the project home page
 * https://docs.google.com/document/d/1yhWCbFyyLLwd3jg0mlIveolN27ZrEEx4yxPpGtWGCd8/edit?tab=t.0#heading=h.vgpv8qkxwoxx
 */

export const ALPHA_GATE = v3Gate('Commerce:ContractsObjectBeta');

/** @note ALPHA. A small number of users are in this gate for early testing and feedback. */
export function hasContractAlphaGate() {
  return hasGate(ALPHA_GATE);
}
export const M1_GATE = v3Gate('Commerce:Contracts:PrivateBeta');
/** @note M1. Termination actions, update payment method and various CRM cards. */
export function hasContractM1Gate() {
  return hasGate(M1_GATE);
}
export const M2_CHANGES_WITHOUT_PRORATION = v3Gate('Commerce:Contracts:M2:ChangesWithoutProration');
/** @note M2 2.1 (changes, change tab on the record page, change quotes and associated actions) */
export function hasM2ChangesWithoutProrationGate() {
  return hasGate(M2_CHANGES_WITHOUT_PRORATION);
}
export const M2_DOWNGRADE_WITH_PRORATION = v3Gate('Commerce:Contracts:M2:DowngradeWithProration');
/** @note M2 2.2 (allow proration for downgrades *only*) */
export function hasM2DowngradeWithProrationGate() {
  return hasGate(M2_DOWNGRADE_WITH_PRORATION);
}
export const M2_UPGRADE_WITH_PRORATION = v3Gate('Commerce:Contracts:M2:UpgradeWithProration');
/** @note M2 2.3 (allow proration for upgrades. requires credit memos, so comes last in release order) */
export function hasM2UpgradeWithProrationGate() {
  return hasGate(M2_UPGRADE_WITH_PRORATION);
}
export function hasM3Gate() {
  // temporary until we have a proper gate for M3+
  return hasContractAlphaGate() && hasContractM1Gate() && hasM2ChangesWithoutProrationGate();
}